// Helper pour normaliser les objets MongoDB avec _id vers id
export function normalizeId<T extends { _id?: string; id?: string }>(item: T): T & { id: string } {
    if (!item) return item as T & { id: string };

    return {
        ...item,
        id: item.id || item._id || '',
    };
}

export function normalizeIds<T extends { _id?: string; id?: string }>(items: T[]): Array<T & { id: string }> {
    return items.map(normalizeId);
}

// Helper pour normaliser les produits des mouvements de stock
export function normalizeMovement(movement: any) {
    const normalized = {
        ...normalizeId(movement),
        type: typeof movement.type === "string" ? movement.type.toLowerCase() : movement.type,
        date: movement.date || movement.movementDate || movement.createdAt,
        paymentType: typeof movement.paymentMethod === "string" ? movement.paymentMethod.toLowerCase() : movement.paymentType,
        paymentMode: typeof movement.paymentMode === "string" ? movement.paymentMode.toLowerCase() : movement.paymentMode,
        paymentId: movement.payment || movement.paymentId,
        orderDiscountType: movement.orderDiscountType || undefined,
        orderDiscountValue: movement.orderDiscountValue != null ? Number(movement.orderDiscountValue) : undefined,
    };

    // Normaliser les items si présents
    if (movement.items && Array.isArray(movement.items)) {
        return {
            ...normalized,
            items: movement.items.map((item: any) => {
                const product = item.product || item.productId;
                if (product && typeof product === 'object') {
                    return {
                        ...item,
                        price: Number(item.finalPrice || item.price || 0),
                        originalPrice: item.originalPrice ? Number(item.originalPrice) : undefined,
                        finalPrice: item.finalPrice ? Number(item.finalPrice) : undefined,
                        discountValue: item.discountValue ? Number(item.discountValue) : 0,
                        productId: {
                            ...normalizeId(product),
                            _id: product._id || product.id,
                        }
                    };
                }
                return {
                    ...item,
                    price: Number(item.finalPrice || item.price || 0),
                    originalPrice: item.originalPrice ? Number(item.originalPrice) : undefined,
                    finalPrice: item.finalPrice ? Number(item.finalPrice) : undefined,
                    discountValue: item.discountValue ? Number(item.discountValue) : 0,
                };
            })
        };
    }

    // Support de l'ancien format (migration)
    if (movement.productId && typeof movement.productId === 'object') {
        return {
            ...normalized,
            productId: movement.productId._id || movement.productId.id || normalized.productId,
            productName: movement.productId.name,
            productCategory: movement.productId.category,
        };
    }

    return normalized;
}

export function normalizeMovements(movements: any[]) {
    return movements.map(normalizeMovement);
}

export function normalizePayment(payment: any) {
    if (!payment) return payment;
    return {
        ...payment,
        _id: payment.id || payment._id,
        id: payment.id || payment._id,
        paymentMode: typeof payment.paymentMode === "string" ? payment.paymentMode.toLowerCase() : payment.paymentMode,
        status: typeof payment.status === "string" ? payment.status.toLowerCase() : payment.status,
        totalAmount: Number(payment.totalAmount || 0),
        amountPaid: Number(payment.amountPaid || 0),
        remainingAmount: Number(payment.remainingAmount || 0),
        payments: (payment.installments || payment.payments || []).map((inst: any) => ({
            ...inst,
            _id: inst.id || inst._id,
            date: inst.paymentDate || inst.date || inst.createdAt,
            amount: Number(inst.amount || 0),
            paymentMethod: typeof inst.paymentMethod === "string" ? inst.paymentMethod.toLowerCase() : inst.paymentMethod,
        })),
        products: (payment.products || []).map((p: any) => ({
            ...p,
            price: Number(p.price || 0),
        })),
    };
}

export function normalizePayments(payments: any[]) {
    return payments.map(normalizePayment);
}
